import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpService } from '../http.service';
import { MachineModuleStatusType } from '@shared/models/types';

@Injectable({
  providedIn: 'root'
})
export class MachineModuleService {
  constructor(private httpService: HttpService) {}

  getStatuses(serialNumber: string): Observable<MachineModuleStatusType[]> {
    return this.httpService
      .httpGet(`machine-modules?serialNumber=${encodeURIComponent(serialNumber)}`)
      .pipe(map((response) => response.modules ?? []));
  }

  setEnabled(serialNumber: string, moduleCode: string, enabled: boolean): Observable<MachineModuleStatusType[]> {
    return this.httpService
      .httpUpdate('machine-modules', { serialNumber, moduleCode, enabled })
      .pipe(map((response) => response.modules ?? []));
  }
}
